import * as actionType from './type';

const INITIAL_STATE = {
    productType: [],
    isLoading: false,
    error: "",
    product : [],
    activeProducts : [],
    selectedProduct: null,
    isProductLoading: false
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_PRODUCT_TYPE: {
            return {
                ...state,
                isLoading: true
            }
        }
        case actionType?.REQUEST_EMPTY_ALL_PRODUCT : {
            return {
                ...state,
                product : [],
                activeProducts : [],
                selectedProduct: null
            }
        }
        case actionType.ERROR_RECEIVED: {
            return {
                ...state,
                isLoading: false,
                isProductLoading: false,
                error: "Please try again"
            }
        }

        case actionType.RECEIVE_PRODUCT_TYPE: {
            return {
                ...state,
                isLoading: false,
                productType: action.payload
            }
        }
        case actionType.REQUEST_GET_ALL_PRODUCT: {
            return {
                ...state,
                isLoading: true
            }
        }
        case actionType.REQUEST_RECEIVED_ALL_PRODUCT: {
            return {
                ...state,
                isLoading: true,
                product : action?.payload
            }
        }
        case actionType?.REQUEST_RECEIVED_ALL_ACTIVE_PRODUCT: {
            return {
                ...state,
                isLoading : false,
                activeProducts : action?.payload
            }
        }
        case actionType.REQUEST_GET_PRODUCT_BY_ID: {
            return {
                ...state,
                isProductLoading: true,
                selectedProduct: null
            }
        }
        case actionType.RECEIVE_GET_PRODUCT_BY_ID: {
            return {
                ...state,
                isProductLoading: false,
                selectedProduct: action?.payload
            }
        }

        default: 
            return state;
    }
}